import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, of } from 'rxjs';
import { ResponseHttpSuccess } from 'library';
import { AuthService } from './auth.service';
import { environment } from 'projects/store/src/environments/environment';
import { StoreFilterV3 } from '../../../interfaces/store-v3';

@Injectable({
  providedIn: 'root'
})
export class StoreV3Service {
  url: string = environment.salesAPIURL;
  store: Record<string, any> = {};

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getPreApproval(requestId: string): Observable<ResponseHttpSuccess> {
    return this.http.get(`${this.url}request/${requestId}/pre-approval`, this.authService.getHttpOptionsBearer())
      .pipe(map((resp: any) => resp as ResponseHttpSuccess));
  }

  getStores(filters?: StoreFilterV3, latitude?: number, longitude?: number): Observable<ResponseHttpSuccess> {
    const params = this.buildQueryParams(filters, latitude, longitude);
    return this.http.get(`${this.url}stores`, {
       ...this.authService.getHttpOptionsBearer(),
       params
     }).pipe(map((resp: any) => resp as ResponseHttpSuccess));


  }

  getNearbyOffices(storeId: string, latitude?: number, longitude?: number): Observable<ResponseHttpSuccess> {
    const params: Record<string, string> = {};

    if (latitude !== undefined) {
      params['latitude'] = latitude.toString();
    }

    if (longitude !== undefined) {
      params['longitude'] = longitude.toString();
    }

    return this.http.get(`${this.url}store/${storeId}/office/nearby`, {
       ...this.authService.getHttpOptionsBearer(),
       params
     }).pipe(map((resp: any) => resp as ResponseHttpSuccess));
  }

  private buildQueryParams(filters?: StoreFilterV3, latitude?: number, longitude?: number): Record<string, string> {
    const params: Record<string, string> = {};

    if (latitude !== undefined) {
      params['latitude'] = latitude.toString();
    }

    if (longitude !== undefined) {
      params['longitude'] = longitude.toString();
    }

    if (!filters) {
      return params;
    }

    if (filters.maxDistance !== undefined) {
      params['maxDistance'] = filters.maxDistance.toString();
    }

    if (filters.administrativeRegions) {
      params['administrativeRegions'] = filters.administrativeRegions;
    }

    return params;
  }
}
